import { Factory } from 'miragejs';
import faker from 'faker';

export default Factory.extend({
  status() {
    return 'A';
  },
  jobId() {
    return faker.random.alpha({ count: 5, casing: 'upper' }).toUpperCase();
  },
  totalStudents() {
    return faker.datatype.number({ max: 36 });
  },
  totalPages() {
    return faker.datatype.number({ max: 4 });
  },
});
